import React from 'react'
import {Switch} from "react-router-dom";
import {VelocityTransitionGroup} from 'velocity-react';
import PushNotification from "virtual_congress/booth_editor/components/push_notification";
import HotspotTracking from "virtual_congress/effects/clicked_hotspots_tracker";
import ExhibitionDefaultRouting from "virtual_congress/exhibition/exhibition_default_routing";
import AddonRenderer from "./addon_renderer";
import RenderedHtmlContent from '../components/rendered_html_content';

export default function App() {
  return (
    <React.Fragment>
      <PushNotification/>
      <RenderedHtmlContent identifier="exhibition.css" />
      {/*<VelocityTransitionGroup component="div" enter={{animation: "fadeIn", delay: 500}} leave={{animation: "fadeOut"}}>*/}
        <Switch>
          <ExhibitionDefaultRouting AddonRenderer={AddonRenderer}/>
        </Switch>
      {/*</VelocityTransitionGroup>*/}
      <HotspotTracking/>
    </React.Fragment>
  )
}
